import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import Routes from './Routes';
import ViaLanguageProvider from './contexts/ViaLanguageProvider';
import { history } from './state/viaStore';
import ViaErrorBoundary from './components/errors/ViaErrorBoundary';
import {isPurCoInstall, setPurcoInstallIndicator} from "./configWeb";


/**
 * The main application wrapper.
 * This will always be at the root of the application.
 *
 * Provides language and routing context to everything.
 */
export default function App() {
    setPurcoInstallIndicator().then(r => {
        console.log('PurCo Installation: ' + isPurCoInstall())
    });
  return (
    <ViaErrorBoundary>
      <ConnectedRouter history={history}>
        <ViaLanguageProvider>
          <Routes />
        </ViaLanguageProvider>
      </ConnectedRouter>
    </ViaErrorBoundary>
  );
}
